export const carrierPortalPages = [
  'carrier-request-list',
  'carrier-transport-list',
  'carrier-tender-hash',
  'carrier-tender-list',
  'carrier-contract-list',
  'carrier-contract-hash',
  'carrier-booking-list',
  'carrier-booking-hash',
  'carrier-booking-edit-hash',
]
